import { render, staticRenderFns } from "./DeleteSelectedForm.vue?vue&type=template&id=56f84a54&"
import script from "./DeleteSelectedForm.vue?vue&type=script&lang=js&"
export * from "./DeleteSelectedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports